import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React from 'react';

import { AttendanceSummaryPanelProps } from './AttendanceSummaryPanel.props';
import { FieldGrid, FieldItem } from '../../../../../components/atoms/FieldGrid';
import { Panel } from '../../../../../components/atoms/Panel';

const VISIT_COLUMNS = ['Date', 'Technician', 'Arrived', 'Left', 'Duration'];

const cellSx = { fontSize: '12px', py: 1, px: 1.5 };
const headerSx = {
  ...cellSx,
  fontWeight: 600,
  bgcolor: 'v4.tableEven',
  borderBottom: 1,
  borderColor: 'v4.border',
};

export const AttendanceSummaryPanel: React.FC<AttendanceSummaryPanelProps> = ({
  attendance = [],
  metrics,
}) => (
  <Panel title="Attendance Summary">
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FieldGrid columns={3}>
        <FieldItem
          label="Total Visits"
          value={String(metrics?.totalVisits ?? 0)}
        />
        <FieldItem
          label="Total On-Site Time"
          value={metrics?.onSiteTime ?? '-'}
        />
        <FieldItem
          label="Avg Duration"
          value={metrics?.avgDuration ?? '-'}
        />
        <FieldItem
          label="Unique Techs"
          value={String(metrics?.uniqueTechs ?? 0)}
        />
        <FieldItem
          label="First Visit"
          value={metrics?.firstVisit ?? '-'}
        />
        <FieldItem
          label="Last Visit"
          value={metrics?.lastVisit ?? '-'}
        />
      </FieldGrid>

      {attendance.length === 0 ? (
        <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
          No attendance records
        </Typography>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {VISIT_COLUMNS.map((col) => (
                  <TableCell key={col} sx={headerSx}>
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {attendance.map((visit, idx) => {
                const checkIn = visit.checkInDateTime ? new Date(String(visit.checkInDateTime)) : null;
                const checkOut = visit.checkOutDateTime ? new Date(String(visit.checkOutDateTime)) : null;
                return (
                  <TableRow
                    key={String(visit.attendanceId ?? idx)}
                    sx={{
                      bgcolor:
                        idx % 2 === 1 ? 'v4.tableEven' : 'transparent',
                    }}
                  >
                    <TableCell sx={cellSx}>
                      {checkIn ? checkIn.toLocaleDateString() : '-'}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {String(visit.siblingNodeName ?? '-')}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {checkIn ? checkIn.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-'}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {checkOut ? checkOut.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-'}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {String(visit.onSiteTime ?? '-')}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  </Panel>
);
